import React from "react";
import "./style.css";
import Frame1 from "../images/Frame_1.png"
import Frame2 from "../images/Frame_2.png"
export const DivWrapper = () => {
    return (
        <section className="promo-wrapper">
            <h2 className="promo-title">АКЦИИ И ПРЕДЛОЖЕНИЯ</h2>

            <div className="promo-grid">
                {/* Блок 1 */}
                <div className="promo-card">
                    <h3 className="promo-subtitle">Бонус за надёжность</h3>
                    <div className="promo-content">
                        <div className="promo-text">
                            <p>
                                Прошёл год и вы ни разу не вызывали помощь?
                                <br />
                                Отлично! Это значит, у вас всё было в порядке — а у нас есть
                                для вас подарок.
                                <br />🔋 Бесплатная зарядка аккумулятора.
                                <br />
                                Это наш способ сказать спасибо за доверие.
                            </p>
                        </div>
                        <img
                            src={Frame1}
                            alt="bonus"
                            className="promo-image"
                        />
                    </div>
                    <button className="promo-btn">Подробнее</button>
                </div>

                {/* Блок 2 */}
                <div className="promo-card">
                    <h3 className="promo-subtitle">Приведи друга — получи бонус!</h3>
                    <div className="promo-content">
                        <div className="promo-text">
                            <p>
                                Ты с нами, тебе нравится — так почему бы не рассказать об этом друзьям?
                                <br />
                                Расскажи друзьям о Road Assist — и получи подарок, как только друг оформит КАСКО.
                                <br />
                                Мы помогаем тебе — ты помогаешь друзьям!
                            </p>
                        </div>
                        <img
                            src={Frame2}
                            alt="friend"
                            className="promo-image"
                        />
                    </div>
                    <button className="promo-btn">Подробнее</button>
                </div>
            </div>
        </section>
    );
};
